const { FONT_SIZE } = require("../constants/fontSize.constants.js");
const { VISIBILITY } = require("../constants/visibility.constants.js");

const A11Y_PREFS_KEY = "a11yPrefs";

const DEFAULT_A11Y_PREFS = {
	readableFont: false,
	spaciousText: false,
	underlineLinks: false,
	reduceMotion: false,
	largeTargets: false,
	strongFocus: false,
};

const A11Y_CLASS_MAP = {
	readableFont: "a11y-readable-font",
	spaciousText: "a11y-spacious",
	underlineLinks: "a11y-underline-links",
	reduceMotion: "a11y-reduce-motion",
	largeTargets: "a11y-large-targets",
	strongFocus: "a11y-strong-focus",
};

const resizeGlobalFonts = (size) => {
	const updateStyle = document.body.style;

	if (size === FONT_SIZE.SMALL) {
		updateStyle.setProperty("--active-font-size", "var(--small-font-size)");
	} else if (size === FONT_SIZE.STANDARD) {
		updateStyle.setProperty("--active-font-size", "var(--default-font-size)");
	} else if (size === FONT_SIZE.LARGE) {
		updateStyle.setProperty("--active-font-size", "var(--large-font-size)");
	} else if (size === FONT_SIZE.EXTRA_LARGE) {
		updateStyle.setProperty("--active-font-size", "var(--xlarge-font-size)");
	} else {
		updateStyle.setProperty("--active-font-size", "var(--default-font-size)");
	}
};

const updateVisibilitySetting = (visibility, colorSettings) => {
	const updateStyle = document.body.style;

	if (visibility === VISIBILITY.MONOCHROME) {
		updateStyle.setProperty("--active-brand-color", "var(--monochrome-text)");
		updateStyle.setProperty("--active-msg-bg", "var(--monochrome-text)");
	} else if (visibility === VISIBILITY.HIGH_CONTRAST) {
		updateStyle.setProperty(
			"--active-brand-color",
			"var(--active-high-contrast)"
		);
		updateStyle.setProperty("--active-msg-bg", "var(--active-high-contrast)");
	} else if (colorSettings) {
		updateStyle.setProperty("--active-brand-color", colorSettings.primary);
		updateStyle.setProperty("--active-msg-bg", colorSettings.accent);
	}
};

const getA11yPrefs = () => {
	try {
		const raw = localStorage.getItem(A11Y_PREFS_KEY);
		if (!raw) return { ...DEFAULT_A11Y_PREFS };
		return { ...DEFAULT_A11Y_PREFS, ...JSON.parse(raw) };
	} catch (e) {
		return { ...DEFAULT_A11Y_PREFS };
	}
};

const saveA11yPrefs = (prefs) => {
	localStorage.setItem(A11Y_PREFS_KEY, JSON.stringify(prefs));
};

const applyA11yPrefs = (prefs) => {
	const next = { ...DEFAULT_A11Y_PREFS, ...prefs };
	Object.keys(A11Y_CLASS_MAP).forEach((key) => {
		document.body.classList.toggle(A11Y_CLASS_MAP[key], Boolean(next[key]));
	});
	return next;
};

const setA11yPref = (key, value) => {
	const prefs = getA11yPrefs();
	prefs[key] = Boolean(value);
	saveA11yPrefs(prefs);
	applyA11yPrefs(prefs);
	return prefs;
};

const resetAccessibilitySettings = (colorSettings, clientId) => {
	const updateStyle = document.body.style;
	updateStyle.setProperty("--active-font-size", "var(--default-font-size)");
	updateStyle.setProperty("--active-brand-color", colorSettings.primary);

	if (colorSettings.primary === "#014ee2" || clientId) {
		updateStyle.setProperty("--active-msg-bg", colorSettings.accent);
	} else {
		updateStyle.setProperty("--active-msg-bg", colorSettings.primary);
	}

	const cleared = { ...DEFAULT_A11Y_PREFS };
	saveA11yPrefs(cleared);
	applyA11yPrefs(cleared);
};

module.exports = {
	DEFAULT_A11Y_PREFS,
	resizeGlobalFonts,
	updateVisibilitySetting,
	resetAccessibilitySettings,
	getA11yPrefs,
	saveA11yPrefs,
	applyA11yPrefs,
	setA11yPref,
};
